<template>
  <PdfViewer :pdfUrl="pdfUrl"/>
</template>

<script>
// @ is an alias to /src
import PdfViewer from '@/components/PdfViewer.vue'

export default {
  name: 'EulaView',
  components: {
    PdfViewer
  },
  inject: ['setTitle'],
  props: {
    lang: String
  },
  data() {
    return {
      pdfUrl: ""
    }
  },
  mounted() {
    this.setPdfUrl()
    this.setTitle(this.$t('app.title.eula'))
  },
  watch: {
    lang() {
      this.setPdfUrl()
      this.setTitle(this.$t('app.title.eula'))
    }
  },
  methods: {
    setPdfUrl() {
      const formattedLang = this.lang.replaceAll("_", "-")
      this.pdfUrl = `/eula-pdf/common/eula_20250318_${formattedLang}.pdf`
    }
  }
}
</script>
